// Modular integration (Vuex cognito required) except forgot password, which requires
// Vuex tenant

import ForgotPassword from './ForgotPassword.vue'
import Login from './Login.vue'
import Logout from './Logout.vue'
import PasswordConfirmation from './PasswordConfirmation.vue'
import PasswordChallenge from './PasswordChallenge.vue'

export {
  ForgotPassword,
  Login,
  Logout,
  PasswordConfirmation,
  PasswordChallenge
}



// WEBPACK FOOTER //
// ./src/components/auth/index.js